import RtkQueryService from '@lok/services/RtkQueryService';

import { transformErrorResponse } from '../api';

const logService = RtkQueryService.injectEndpoints({
  endpoints: (builder) => ({
    createLog: builder.mutation({
      query: (data) => {
        if (data.headers) {
          const { headers, ...rest } = data;

          return {
            url: '/v1/log/',
            method: 'POST',
            data: rest,

            headers: {
              'Content-Type': 'application/json',
              ...headers
            }
          };
        }

        return {
          url: '/v1/log/',
          method: 'POST',
          data
        };
      },
      transformErrorResponse
    })
  })
});

export const { useCreateLogMutation } = logService;
